const _i18n_msg = {
  plz_wait: { EN : `Please wait...`, KO : `잠시만 기다려주세요.....`, JP : `お待ちください...` },
  wsfinder: { EN : `WebShell`, KO : `웹쉘 탐지`, JP : `WebShell` },
  webcastle: { EN : `Web Hacking`, KO : `웹 방화벽`, JP : `Web Hacking` },
  wfdetect: { EN : `Web Forgery`, KO : `웹 위변조`, JP : `Web Forgery` },
  wmds: { EN : `Web Malware\r\nDistribution`, KO : `웹 악성코드\n유포지 탐지`, JP : `Web Malware\r\nDistribution` },
  configure: { EN : `Configuration \r\n Status`, KO : `설정 현황`, JP : `構成 \r\n ステータス`, },
  // using: { JP : `使用する`, },

  contents: { EN : `Contents`, KO : `내용`, JP : `Contents`, },
  reg_date: { EN : `Registration / Update Date`, KO : `등록 정보 및 갱신일`, JP : `登録 / 更新日`, },
  service_type: { EN : `Service Type`, KO : `구독 정보`, JP : `サービスタイプ`, },
  service_type_prev: { EN : `Changed Service Type`, KO : `변경된 구독 정보`, JP : `変更されたサービスタイプ`, },
  protect_function: { EN : `Protection Function`, KO : `보호 기능`, JP : `保護機能`, },
  included: { EN : `Included`, KO : `포함`, JP : `付属`, },
  choice_date: { EN : `plz, choice date`, KO : `날짜를 선택하세요`, JP : `日付を選択してください`, },
  generating_report: { EN : `Generating report`, KO : `보고서 생성중`, JP : `レポートの生成`, },
  wmds_patten_update : { EN : `WMDS Pattrn Update`, KO : `악성코드 유포 탐지 시스템 패턴 업데이트`, JP : `WMDSパターンの更新`, },
  wsfinder_pattern_log : { EN : `WSFinder Pattern Log`, KO : `웹쉘 탐지 시스템 패턴 로그`, JP : `WSFinderパターンログ`, },
  wfdetector_domain_total : { EN : `WFdetector Detection(Domain) Total`, KO : `위변조 탐지(도메인) 총계`, JP : `WFdetector検出 (サーバー) 合計`, },
  wfdetector_server_total : { EN : `WFdetector Detection(Server) Total`, KO : `위변조 탐지(도메인) 총계`, JP : `WFdetector検出 (サーバー) 合計`, },

  // wc
  detectionnly : {  EN : `Level`, KO : `레벨`, JP : `レベル`, },
  service : { EN : `Service`, KO : `서비스`, JP : `サービス`, },
  name : { EN : `Name`, KO : `이름`, JP : `名前`, },
  level : { EN : `Level`, KO : `레벨`, JP : `レベル`, },
  domain : { EN : `Domain`, KO : `도메인`, JP : `ドメイン`, },
  mode : { EN : `Mode`, KO : `모드`, JP : `モード`, },
  on : { EN : `On`, KO : `사용`, JP : `On`, },
  off : { EN : `Off`, KO : `미사용`, JP : `Off`, },
  block : { EN : `Block`, KO : `차단`, JP : `ブロック`, },
  detect : { EN : `Detect`, KO : `탐지`, JP : `検出`, },
  schedule : { EN : `Schedule(Daily)`, KO : `점검일정(일별)`, JP : `スケジュール(毎日)`, },
  policy : { EN : `Policy`, KO : `정책`, JP : `ポリシー`, },
  ssdeep : { EN : `SSDEEP`, KO : `유사도`, JP : `SSDEEP`, },
  obfuscation : { EN : `Obfuscation`, KO : `난독화`, JP : `難読化`, },
  realtime : { EN : `Realtime`, KO : `실시간`, JP : `リアルタイム`, },
  backup : {  EN : `Backup`, KO : `격리`, JP : `バックアップ`, },
  total : { EN : `Total`, KO : `총합`, JP : `合計`, },
  server_name : { EN : `Server name`, KO : `서버이름`, JP : `サーバー名`, },
  diagram : { EN : `Diagram`, KO : `다이어그램`, JP : `選択性`, },
  risk : { EN : `Risk`, KO : `위험도`, JP : `リスク`, },
  no : { EN : `No.`, KO : `#`,  JP : `No.`, },
  attacker_ip : { EN : `Attacker IP`, KO : `공격자 IP`, JP : `Attacker IP`, },
  server : { EN : `Server`, KO : `서버`, JP : `サーバー`, },
  detail_event : { EN : `Details Events`, KO : `이벤트 상세`, JP : `イベント詳細`, },
  message : { EN : `Message`, KO : `정보`, JP : `メッセージ`, },
  target : {  EN : `Target`, KO : `대상`, JP : `ターゲット`, },

  // wsfinder
  detected_value : { EN : `Detected Value`, KO : `탐지된 값`, JP : `検出値`, },
  username : { EN : `Username`, KO : `사용자명`, JP : `ユーザー名`, },
  ev : { EN : `Report period`, KO : `보고서 기간`, JP : `レポート期間`, },
  event : { EN : `Event`, KO : `이벤트`, JP : `イベント`, },
  isolation : { EN : `Isolation`, KO : `격리`, JP : `隔離`, },
  report_period : {  EN : `Report period`, KO : `보고서 기간`, JP : `レポート期間`, },
  contract : { EN : `Contract`, KO : `계약`, JP : `契約`, },
  status : { EN : `Status`, KO : `상태`, JP : `ステータス`, },
  count : { EN : `Count`, KO : `현황`, JP : `カウント`, },
  pattern : { EN : `Pattern`, KO : `패턴`, JP : `パターン`, },
  category : { EN : `Category`, KO : `구분`, JP : `カテゴリー`, },
  path : { EN : `Path`, KO : `경로`, JP : `パス`, },
  detect_time : { EN : `Detected\r\nTimestamp`, KO : `탐지 시각`, JP : `検出された\r\nタイムスタンプ`, },
  updated : { EN : `Updated`, KO : `업데이트 일자`, JP : `更新しました`, },
  date : { EN : `Date`, KO : `일자`, JP : `日付`, },
  type : { EN : `Type`, KO : `정책`, JP : `タイプ`, },
  code : { EN : `Code`, KO : `코드`, JP : `コード`, },
  deleted : { EN : `Deleted`, KO : `삭제일`, JP : `検出`, },

  // WMDS
  fqdn : { EN : `FQDN`, KO : `FQDN`, JP : `FQDN`, },
  domain_fqdn : { EN : `Domain name(FQDN)`, KO : `도메인 이름(FQDN)`, JP : `ドメイン名(FQDN)`, },
  this_month : { EN : `This Month`, KO : `이번 달`, JP : `今月`, },

  // wf
  folder : { EN : `folder`, KO : `폴더`, JP : `フォルダー`, },
  file : { EN : `file`, KO : `파일`, JP : `ファイル`, },
  host : { EN : `host`, KO : `호스트`, JP : `ホスト`, },
  ip : { EN : `IP`, KO : `IP 주소`, JP : `IP`, },
  daily_domain_detect : { EN : `Daily detection of domain`, KO : `일별 도메인 탐지`, JP : `毎日のドメイン検出`, },
  changed : { EN : `Changed`, KO : `변화됨`, JP : `変更しました`, },
  action : { EN : `Action`, KO : `조치`, JP : `アクション`, },
  domain_and_server : { EN : `Domain Name / Web Server`, KO : `도메인명 / 웹서버`, JP : `ドメイン名 / Webサーバー`, },

  min : { EN : `min`, KO : `분`, JP : `分`, },
  hour : { EN : `hour`, KO : `시`, JP : `時間`, },
  // risk : { JP : `リスク`, },
  // etc
  generated_report : { EN : `Generated Report`, KO : `보고서 생성 완료!`, JP : `生成されたレポート`, },
  generated_report_failed : { EN : `generate reporting failed`, KO : `보고서 생성 실패!`, JP : `レポートの生成に失敗しました`, },
  export_done : { EN : `export done!`, KO : `보고서가 곧 다운로드됩니다!!`, JP : `出力が完了しました`, },

  // wmds
  scan : { EN : `scan count`, KO : `점검 수`, JP : `スキャン数`, },
  page : { EN : `scan page`, KO : `점검 페이지`, JP : `ページをスキャン`, },
  max_page : { EN : `Max Page`, KO : `최대 점검 페이지`, JP : `最大ページ数`, },
  detail : { EN : `Detail`, KO : `상세`, JP : `詳細`, },
  // status : { JP : `ステータス`, },
}

const _i18n_warning = {
  download : {
    EN: `You have already requested the download.`,
    KO: `이미 다운로드를 요청했습니다.`,
    JP: `すでにダウンロードをリクエストしています`
  }
}

const _i18n_error = {
  makePDF  : {
    EN: `Error Occurred. Contact Developer`,
    KO: `문제가 발생했습니다. 담당자에게 문의해주세요.`,
    JP: `エラーが発生しました。 開発者に連絡してください`
  }
}

const i18n_toastr = {
  _i18n_msg,
  _i18n_warning,
  _i18n_error
}

export default i18n_toastr